import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

//https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex - authentication

const store = new Vuex.Store({
  state: {
    user: null,
    status: "",
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, params) {
      state.status = "success";
      state.user = params.user;
    },
    auth_error(state) {
      state.status = "error";
    },
    set_state_user(state, user) {
      state.user = user;
    },
    logout(state) {
      state.status = "";
      state.user = null;
    },
  },
  actions: {
    set_auth_success({ commit }, params) {
      return new Promise((resolve, reject) => {
        try {
          commit("auth_success", {
            user: params.user,
          });
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    set_current_user({ commit }, user) {
      return new Promise((resolve) => {
        commit("set_state_user", user);
        resolve();
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        resolve();
      });
    },
  },
  getters: {
    authStatus: (state) => state.status,
    user: (state) => state.user,
  },
});

/** this will automatically populate **/
/** the vuex store for all modules on application load **/
// import modules from './modules';
// for (const moduleName of Object.keys(modules)) {
//   if (modules[moduleName].actions && modules[moduleName].actions.initStore) {
//     store.dispatch(moduleName + '/initStore')
//   }
// }

export default store;
